import { MutableRefObject, useCallback, useEffect } from 'react'

type Payload = {
  isOpen: boolean
  closeHandler: () => void
  ref: MutableRefObject<HTMLElement | null>
}

export const useCloseMenu = ({ isOpen, closeHandler, ref }: Payload) => {
  const clickHandler = useCallback(
    (e: MouseEvent) => {
      if (!isOpen) return

      if (!ref.current?.contains(e.target as Node)) {
        closeHandler()
      }
    },
    [closeHandler, ref, isOpen]
  )

  useEffect(() => {
    document.addEventListener('click', clickHandler, { capture: true })

    return () => {
      document.removeEventListener('click', clickHandler, { capture: true })
    }
  }, [clickHandler])
}
